export const getDataFromStorage = (key: string) => localStorage.getItem(key);
